
<template>
    <div >
      <div class="info-list">
       <div class="info-item" v-for="(item,index) in dataList" :key="index">
         <div class="content flx-justify-between ">
           <div class="title">
            <img :src="item.img" alt="">
            {{item.title}}
          </div>
           <div>
            <div id="description">
             {{ item.content }}
              </div>
           </div>
         </div>
       </div>

       <!-- 更多 .info-item -->
  </div>
    </div>
  </template>
  <script>
  
  
  /**
   * Index-1 component
   */
  export default {
    name:"registrateInfo",
    components: {
    },
    data(){
      return {
          dataList:[
            {
              title:"公司营业执照彩色扫描件",
              content:" 必须由中国大陆,香港,台湾出具;营业执照有效期，必须距离营业期限到期日超过45天",
              img:this.$ossUrl+'icons/platform/platformIcon1.png'
            },
            {
              title:"法定代表人身份证彩色扫描件",
              content:"姓名与营业执照法定代表人的姓名、注册亚马逊账户上的姓名一致",
              img:this.$ossUrl+'icons/platform/platformIcon2.png'
            },
            {
              title:"可进行国际付款的有效信用卡",
              content:"VISA或Mastercard,首选VISA;需确认开通销售国币种的支付功能；",
              img:this.$ossUrl+'icons/platform/platformIcon3.png'
            },
            {
              title:"准确且最新的联系方式",
              content:"联系人的电子邮箱、电话号码;公司的地址、联系电话",
              img:this.$ossUrl+'icons/platform/platformIcon4.png'
            },
            {
              title:"用接收付款的银行账户",
              content:"可选用亚马逊全球收款，海外银行账户，第三方收款(已参加“支付服务商计划” 的支付服务商）欧洲站点的收款账户请备对公账户",
              img:this.$ossUrl+'icons/platform/platformIcon5.png'
            },
          ]
      }
    },
    methods: {
     
    }
  };
  </script>
  <style src="./componentsIndex.css" scoped></style>